import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { Pages } from 'constants/menu';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTaskTabForTask } from './taskTabs';

export const useNavigateToTask = () => {
  const navigate = useNavigate();

  const navigateToTask = useCallback(
    (task: AutopilotTaskDto) => {
      if (!task) return;

      const { campaignId, contractId, category, agencyId } = task;

      const isContractTask = !!task.campaignId && !!task.contractId;

      if (!agencyId || !campaignId) return;
      const tab = getTaskTabForTask(task);
      let navigateTo: string = '';
      if (isContractTask) {
        navigateTo = `/${Pages.AGENCIES}/${agencyId}/${Pages.CAMPAIGNS}/${campaignId}/${Pages.CONTRACTS}/${contractId}/${Pages.CONTRACT_TASKS}${category?.workflowType ? `#tab=${tab}` : ''}`;
      } else {
        navigateTo = `/${Pages.AGENCIES}/${agencyId}/${Pages.CAMPAIGNS}/${campaignId}/${Pages.CAMPAIGN_TASKS}${category?.workflowType ? `#tab=${tab}` : ''}`;
      }

      navigate(navigateTo);
    },
    [navigate]
  );

  return navigateToTask;
};
